import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { SetTagsAction } from '~src/spacesPlatform/actions/SetTagsActions';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import {
    reloadSpaceIfUpdatingCurrentSpace
} from '~src/spacesPlatform/sagas/content/RefreshContentSagas';
import {
    replaceDatasourceIdWithConnectionIdForMixedContent
} from '~src/spacesPlatform/sagas/SpacesSagaHelpers';
import { ChangeContentTagsAction } from '~src/tags/services/ChangeContentTagsAction';

export function* handleSetTags(action: SetTagsAction): SagaIterator {
  try {
    //Hack to mitigate Datasource API expecting DataConnectionId
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.content);
    //endHack

    yield call(changeContentTags, mutatableContentCopy);

    // reload the space if we changed its tags so that opening the tags dialog again will have the updated tags info
    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.content);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function changeContentTags(contentCollection: IContentInfo[]): Promise<IResult> {
  return ChangeContentTagsAction.showChangeTagsForMixedContentDialog(contentCollection);
}
